<template>
  <div class="payment-view-widget">
    <v-chip
      :color="getPaid(order).color"
      class="payment-badge"
      dark
    >
      {{ getPaid(order).title }}
    </v-chip>
    <div
      v-if="order.total_paid > 0 && permissions.orders.viewprices"
      class="payment-list"
    >
      <v-row
        v-for="(payment, i) in order.payments"
        :key="i"
        class="payment-row"
      >
        <v-col cols="6" class="method-col">
          {{ `${getMethod(payment.method).title}`}}<br/>
          <template v-if="payment.method === 2">
            {{ `(${payment.parcels}x)` }}
          </template>
        </v-col>
        <v-col cols="6" class="price-col">
          {{ `${formatCurrency(payment.value)}` }}<br/>
          <template v-if="payment.method === 1 || payment.method === 2">
            {{ `${payment.taxes}% (${formatCurrency(parseFloat(parseFloat(payment.taxes) / 100) * payment.value)})` }}
          </template>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import orders from '@/components/orders/mixins/index'
import cashflow from '@/components/financial/cashflow/mixins/index'

export default {
  mixins: [ appdata, utils, orders, cashflow ],
  props: {
    order: {
      type: Object,
      default: function () {
        return {}
      }
    }
  }
}
</script>

<style lang="scss">
.payment-view-widget {
  #app & {
    position: relative;
    .payment-badge {
      width: 100% !important;
      .v-chip__content {
        width: 100% !important;
        justify-content: center;
        transition: all 300ms linear;
      }
    }
    .payment-list {
      position: absolute;
      top: 25px;
      width: 100%;
      height: auto;
      overflow: hidden;
      border-radius: 7px;
      background: #f2f2f2;
      opacity: 0;
      transition: all 300ms linear;
      box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
      .payment-row {
        padding: 2px 5px;
        font-size: 11px;
        font-weight: 500;
        color: #777;
        &:not(:last-child) {
          border-bottom: 1px dashed #ccc;
        }
        * {
          padding: 0px !important;
          line-height: 14px;
        }
        .method-col {
          text-align: left;
        }
        .price-col {
          text-align: right;
        }
      }
    }
    &:hover {
      .payment-list {
        opacity: 1 !important;
      }
      .payment-badge {
        .v-chip__content {
          padding-bottom: 7px !important;
        }
      }
    }
  }
}
</style>